import { Box, Typography } from '@mui/material'
import HourglassBottomRoundedIcon from '@mui/icons-material/HourglassBottomRounded'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { ICON_SIZE, UI_FONT_SIZE } from '@/shared/styles/typography'

interface Props {
  /**
   * 意図した batch 経路 (= 設定「しっかり文字起こし」オン) での生成か (log/207)。
   * true なら「選んだ設定どおりに動いている」説明、 false (既定) なら
   * 「streaming から低速経路に切り替わった」通知を出す (異常であることを隠さない)。
   */
  isIntendedBatch?: boolean
}

/**
 * 低速経路 (legacy batch) での文字起こし進行中 (= engine.isSlowTranscription).
 * 2 つの意味を isIntendedBatch で出し分ける (log/207 の 1 bit):
 * - 意図した batch: 設定「高速SOAP生成」オフの通常動作。切り替わったのではなく
 *   選んだ経路の説明として出す。
 * - 劣化 fallback: finalize response の transcription_mode='batch_fallback'
 *   (backend の GS-3 / chunk 欠落検知) または client 起点 MediaRecorder fallback。
 * どちらも録音は保存済で処理が進んでいる安心情報なので warn ではなく info token で出す
 * (= InterruptionSavedBanner と同方針).
 */
export const SlowTranscriptionBanner = ({ isIntendedBatch = false }: Props) => (
  <Box
    sx={{
      backgroundColor: colorTokens.state.infoBg,
      color: colorTokens.state.infoFg,
      borderRadius: `${RADIUS.md}px`,
      py: 1,
      px: 1.5,
      display: 'flex',
      gap: 1,
      alignItems: 'flex-start',
    }}
  >
    <HourglassBottomRoundedIcon
      sx={{
        color: colorTokens.state.infoFg,
        fontSize: ICON_SIZE.md,
        flexShrink: 0,
      }}
    />
    <Typography
      component="span"
      sx={{
        fontSize: UI_FONT_SIZE.label,
        lineHeight: 1.4,
      }}
    >
      {isIntendedBatch
        ? 'しっかり文字起こし中です。正確さを優先する設定のため、SOAP の生成に時間がかかります。完了を待たずに次の録音を開始できます。'
        : '低速モードで文字起こし中です。SOAP の生成に通常より時間がかかることがあります。完了を待たずに次の録音を開始できます。'}
    </Typography>
  </Box>
)
